export default "__VITE_ASSET__BG7hYcM$__"